import { render } from "./HowItworks.vue?vue&type=template&id=6c94e2a4&scoped=true"
const script = {}

import "./HowItworks.vue?vue&type=style&index=0&id=6c94e2a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c94e2a4"]])

export default __exports__